import { CloseDialogWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('CloseDialog')
export class CloseDialogNodeConnectorProvider extends ConnectorProvider<CloseDialogWorkflowNode> {}
